import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import type { PrefetchedUserDataProps } from 'src/shared/prefetch';
import { withPrefetchedData } from 'src/shared/prefetch';

import { PetitionCommentPageContextProvider, prefetchPageContext } from 'src/app/pages/petitionComment/pageContext';
import type { PetitionCommentPagePrefetchedDataProps } from 'src/app/pages/petitionComment/pageContext';

import { Layout } from '../layout';
import type { UserInfo } from '../legacy/types';
import { prefetchUserDataUserInfo, useUserInfo } from '../legacy/userInfo';

import { PetitionCommentErrorHandler } from './ErrorHandler';
import { PetitionHeaderContainer } from './legacy/Header';

export const PetitionComment = withPrefetchedData(
	function PetitionComment({
		prefetchedData,
		prefetchedUserData,
	}: PetitionCommentPagePrefetchedDataProps & PrefetchedUserDataProps<UserInfo>): JSX.Element {
		const { slug, id } = useKnownAvailableParams<{ slug: string; id: string }>();
		const userInfoState = useUserInfo(slug, prefetchedUserData);

		return (
			<>
				<PetitionHeaderContainer slug={slug} userInfoState={userInfoState} />
				<PetitionCommentPageContextProvider
					commentId={id}
					petitionSlug={slug}
					prefetchedData={prefetchedData}
					errorHandler={PetitionCommentErrorHandler}
					loadingFallback={<Loader size="m" my={256} mx="auto" />}
				>
					<Layout />
				</PetitionCommentPageContextProvider>
			</>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [PetitionHeaderContainer],
		prefetchUserData: async (context) => prefetchUserDataUserInfo(context),
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context.params.id!, context),
	},
);
